<template>
    <div class="tips">
        {{field.value}}
    </div>
</template>

<style lang="scss" scoped>
    .tips{
        background: rgba(74, 142, 247, 0.1);
        height: 30px;
        line-height: 30px;
        margin: 0 0 20px 20px;
        color: #4a8ef7;
        padding-left: 10px;
        text-align: center;
    }
</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */
    export default {
        name: 'tms-type-tips',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            config: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },

        components: {},

        mounted() {

        },

        methods: {}
    }

</script>
